var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { LineStyleType } from '../../../view-data/shared/line/general/line-style-type';
import { ArrowStyleType } from '../../../view-data/shared/line/general/arrow-style-type';
var LineGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(LineGeneralSettingComponent, _super);
    function LineGeneralSettingComponent(injector, arrowStyleTypeService, lineStyleTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.arrowStyleTypeService = arrowStyleTypeService;
        _this.lineStyleTypeService = lineStyleTypeService;
        _this.lineStyleTypes = [];
        _this.arrowStyleTypes = [];
        _this.arrowStyleTypes = _this.arrowStyleTypeService.getAll();
        _this.lineStyleTypes = _this.lineStyleTypeService.getAll();
        return _this;
    }
    Object.defineProperty(LineGeneralSettingComponent.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this.data.stroke = v;
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineGeneralSettingComponent.prototype, "strokeWidth", {
        get: function () {
            return this._strokeWidth;
        },
        set: function (v) {
            this.data.strokeWidth = v;
            this._strokeWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineGeneralSettingComponent.prototype, "selectedLineType", {
        get: function () {
            return this._selectedLineType;
        },
        set: function (v) {
            this.data.lineType = v.id;
            this._selectedLineType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineGeneralSettingComponent.prototype, "isArrow", {
        get: function () {
            return this._isArrow;
        },
        set: function (v) {
            if (v) {
                this.data.arrow.arrowStyle = this._selectedArrowStyleType.id;
            }
            else {
                delete this.data.arrow.arrowStyle;
            }
            this.data.arrow.isArrow = v;
            this._isArrow = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineGeneralSettingComponent.prototype, "selectedArrowStyleType", {
        get: function () {
            return this._selectedArrowStyleType;
        },
        set: function (v) {
            this.arrow.arrowStyle = v.id;
            this._selectedArrowStyleType = v;
        },
        enumerable: true,
        configurable: true
    });
    LineGeneralSettingComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    LineGeneralSettingComponent.prototype.validateStrokeWidth = function () {
        if (_.isNil(this.strokeWidth) || this.strokeWidth < 0) {
            this.strokeWidth = this.preStrokeWidth;
            return;
        }
        this.preStrokeWidth = this.strokeWidth;
    };
    LineGeneralSettingComponent.prototype.initData = function () {
        var _this = this;
        this._stroke = this.data.stroke;
        this._strokeWidth = this.data.strokeWidth;
        this.preStrokeWidth = this.data.strokeWidth;
        this.arrow = this.data.arrow;
        if (this.arrow) {
            this._isArrow = this.arrow.isArrow;
            if (this.data.arrow.arrowStyle || this.data.arrow.arrowStyle === ArrowStyleType.CommonLeft) {
                this.selectedArrowStyleType = this.arrowStyleTypes.find(function (v) { return v.id === _this.data.arrow.arrowStyle; });
            }
            else {
                this.selectedArrowStyleType = this.arrowStyleTypes[0];
            }
        }
        if (this.data.lineType || +this.data.lineType === LineStyleType.Solid) {
            this.selectedLineType = this.lineStyleTypes.find(function (v) { return v.id === +_this.data.lineType; });
        }
        else {
            this.selectedLineType = this.lineStyleTypes[0];
        }
    };
    LineGeneralSettingComponent.prototype.setStrokeColor = function (color) {
        this.stroke = color;
    };
    __decorate([
        Input()
    ], LineGeneralSettingComponent.prototype, "data", void 0);
    LineGeneralSettingComponent = __decorate([
        Component({
            selector: 'line-general-setting',
            styles: [".straight-line-general{ .form-inline-label{ float: left; margin-top:3px; } } .color-picker{ width: 100px; }"],
            template: "<div [busyIf]=\"isLoading\" class=\"straight-line-general\"> <div class=\"fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line\"> <div class=\"fe-transverse-title\">{{lc(\"StraightLineColor\")}}:</div> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"stroke\" (sentColor)=\"setStrokeColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-form-group clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"LineWidth\")}}:</div> <input type=\"number\" class=\"fe-vertical-input\" name=\"strokeWidth\" [(ngModel)]='strokeWidth' (change)=\"validateStrokeWidth()\" /> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"LineType\")}}:</div> <div class=\"fe-vertical-component\"> <ng-select [items]=\"lineStyleTypes\" bindLabel=\"name\" [(ngModel)]=\"selectedLineType\" [clearable]=\"false\" [searchable]=\"false\"> <ng-template ng-label-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> <ng-template ng-option-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> </ng-select> </div> </div> </div> </div> <div class=\"fe-modal-body\"> <div class=\"fe-option-head\"> <label> <input type=\"checkbox\" name=\"isArrow\" [(ngModel)]=\"isArrow\"> <span>{{lc(\"Arrow\")}}</span> </label> </div> <div class=\"fe-modal-content clearfix\" *ngIf=\"isArrow\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"ArrowStyle\")}}:</div> <div class=\"fe-vertical-component\"> <ng-select [items]=\"arrowStyleTypes\" [(ngModel)]=\"selectedArrowStyleType\" [clearable]=\"false\" [searchable]=\"false\"> <ng-template ng-label-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> <ng-template ng-option-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> </ng-select> </div> </div> </div> </div> </div>"
        })
    ], LineGeneralSettingComponent);
    return LineGeneralSettingComponent;
}(ConfigureComponentBase));
export { LineGeneralSettingComponent };
